"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_i18next_1 = require("react-i18next");
const AppContextProvider_1 = require("../../../../../shared/contexts/AppContextProvider");
const hooks_1 = require("../../../../../shared/hooks");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const PrefiltersReset = ({ displayOnlyMobile, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { getAll, remove, clear } = (0, hooks_1.usePrefiterParams)();
    const { prefiltersData } = (0, AppContextProvider_1.useAppContext)();
    const { windowWidth } = (0, hooks_1.useWindowWidth)();
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const prefiltersAllowRemoval = (0, react_1.useMemo)(() => {
        if (!prefiltersData)
            return [];
        return prefiltersData.filter(p => p.removable);
    }, [prefiltersData]);
    const appliedFilters = Object.entries(getAll()).filter(([key, value]) => {
        return value != null;
    });
    const shouldRender = () => {
        if (windowWidth > 768 && displayOnlyMobile)
            return false;
        if (!prefiltersData || Object.values(getAll()).every(v => v === null))
            return false;
        return appliedFilters.some(applied => prefiltersAllowRemoval.find(p => p.name === applied[0]));
    };
    const handleResetClick = () => {
        clear();
        window.location.reload();
    };
    const handleRemoveClick = (filterKey) => {
        remove(filterKey);
        window.location.reload();
    };
    const renderAppliedList = () => {
        return appliedFilters.filter(applied => prefiltersAllowRemoval.find(p => p.name === applied[0])).map((filter) => {
            return (react_1.default.createElement("li", { className: `${windowWidth > 768 ? 'w-50' : 'w-100'} d-flex justify-content-between mb-2 preto70` },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronRight, className: "mr-3" }),
                    t(`lblPrefilter-${filter[0]}`)),
                react_1.default.createElement("button", { className: "rad5 b-none bkzero vermelho hover hvermelho ml-2 s12", title: t('Remover'), onClick: () => handleRemoveClick(filter[0]) },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimes }))));
        });
    };
    if (!shouldRender())
        return null;
    return (react_1.default.createElement(reactstrap_1.Alert, { color: "warning", className: "w-100" },
        react_1.default.createElement("p", { className: "preto70 s16 f500 mb-0 link click", onClick: () => setExpanded(!expanded) },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faQuestionCircle, className: 'mr-3' }),
            t('NaoEncontrouOqueProcurava')),
        expanded && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("hr", { className: "mb-2 mt-1" }),
            react_1.default.createElement("p", { className: "s12 mb-2 preto70" }, t('AlertPrefiltrosMsg')),
            react_1.default.createElement("ul", { className: "s12 mb-1 p-0" }, renderAppliedList()),
            react_1.default.createElement("button", { className: "btn-generic--segundo bkbranco", onClick: () => handleResetClick() }, t('BtnRestaurarCatalogo'))))));
};
exports.default = PrefiltersReset;
